import type { IAssetVisit, IAssetVisitEvent, Maybe } from '@nova/core';

export interface ArrivalEvent extends IAssetVisitEvent {
  createDateTime: string;
}

export interface ArrivalMessageThread {
  id: string;
  unreadMessagesCount?: number;
  lastChangedDateTime?: string;
}

export interface ArrivalIdValidationData {
  status?: Maybe<string>;
  rejectReasons?: Maybe<string[]>;
}

/** An asset visit with the joins the arrivals drawer asks for. */
export interface Arrival extends IAssetVisit {
  warehouseId: string;
  createDateTime: string;
  checkInAcknowledged?: boolean;
  assetVisitEvents: ArrivalEvent[];
  company?: Maybe<{ id?: string; name?: string }>;
  messageThread?: Maybe<ArrivalMessageThread>;
  idValidationData?: Maybe<ArrivalIdValidationData>;
  vehicleObservations?: unknown[];
}

export enum ArrivalsTab {
  Pending = 'pending',
  Planned = 'planned',
  Resolved = 'resolved'
}

export enum ArrivalStatus {
  PendingUpdate = 'pending-update',
  AppointmentCreated = 'appointment-created',
  Rejected = 'rejected',
  Early = 'early',
  Late = 'late',
  OnTime = 'on-time'
}

export interface ArrivalsDateGroup {
  date: string;
  arrivals: Arrival[];
}

export interface ArrivalUnreadDetails {
  id: string;
  unreadMessagesCount: number;
  lastDriverMessageTimestamp: Maybe<string>;
}
